import React, {useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService'
import MetaDB from './MetaDB';
import SupportUs from './features/supporters/SupportUs';
import EventsList from './features/events/EventsList';

function Home(props) {
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        async function fetchData() {
            setAuthenticated(await authService.isAuthenticated());
        }
        fetchData()
    }, []);

    return (
        <div>
            {authenticated && <SupportUs/>}
            <MetaDB/>
            <EventsList />
        </div>
    );
}

export default Home;